/**
 * Company and KeyID pair for an equipment instance (used in distinct equipment dropdown).
 */
export interface EquipmentCompanyKeyItemDto {
  vpCompanyID: number | null;
  keyID: number;
  displayLabel: string;
}
